import { useNavigate } from 'react-router-dom';
import PageWrapper from 'components/Base/PageWrapper';
import { RoutesPaths } from 'routes/Routes.types';
import { ActionPlan as ActionPlanIcon } from 'assets/icon/icon';
import TacticTable from './TacticTaskTable/TacticTable';
import CardContent from '../../../../components/Base/Layout/Content/CardContent';
import PageHeader from './PageHeader';

const AllElcsActionPlan = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(`/app/${RoutesPaths.ELCS}`);
  };

  return (
    <PageWrapper
      title="ELCs"
      backButton={{
        labelPrefix: 'ELCs',
        tooltip: 'Back to ELCs',
        onClick: handleBack,
      }}
    >
      <>
        <PageHeader
          subtitle="Action Plan"
          subtitleIcon={<ActionPlanIcon size={16} />}
        />
        <CardContent>
          <TacticTable isAllElcs />
        </CardContent>
      </>
    </PageWrapper>
  );
};

export default AllElcsActionPlan;
